import React, { useEffect, useState } from "react";
import {
  Button,
  createStyles,
  makeStyles,
  Modal,
  Theme,
} from "@material-ui/core";
import ChipInput from "material-ui-chip-input";
import { request } from "../../service/common";
import { useParams } from "react-router";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import MultiSelect from "react-multi-select-component";
import "./project.css";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store";
import {
  addAction,
  getProjectById,
  editAction,
  deleteAction,
  addRoles,
} from "../../store/project";
import { toast } from "react-toastify";
const type_list = [
  {
    name: "Get",
    value: "get",
  },
  {
    name: "Post",
    value: "post",
  },
  {
    name: "Put",
    value: "put",
  },
  {
    name: "Delete",
    value: "delete",
  },
];
const ProjectView = () => {
  const dispatch = useDispatch();
  let { id }: any = useParams();
  const [rolesArray, setRolesArray] = useState<any>([]);
  const [rolesOption, setRolesOptions] = useState<any>([]);
  const [selectedRoles, setSelectedRoles] = useState<any>([]);
  const [openActionModal, setActionModal] = useState(false);
  const [openRoleModal, setRoleModal] = useState(false);
  const [editActions, setEditAction] = useState(false);
  const [actionError, setActionError] = useState("");
  const [actionId, setActionId] = useState("");

  const { selectedProject, loadingProject, roles } = useSelector(
    (state: RootState) => state.project
  );

  const closeActionModal = () => {
    setValue("name", "");
    setSelectedRoles([]);
    setActionModal(false);
    setEditAction(false);
  };
  const OpenActionModal = () => {
    let rolesArr: any = [];
    roles.map((role: any) => {
      rolesArr.push({ label: role, value: role });
    });
    console.log(rolesArr);
    setRolesOptions(rolesArr);
    setActionModal(true);
  };
  const OpenRolesModal = () => {
    setRoleModal(true);
    setRolesArray(roles);
  };
  const closeRoleModal = () => {
    setRoleModal(false);
  };

  useEffect(() => {
    getProject();
  }, []);

  const getProject = async () => {
    dispatch(getProjectById(id));
  };
  const addRole = async (role: any) => {
    setRolesArray([...rolesArray, role]);
  };
  const removeRole = async (role: any, index: any) => {
    let currentRole = rolesArray.filter((value: any, i: any) => i != index);
    setRolesArray(currentRole);
  };
  const actionSchema = yup.object().shape({
    name: yup.string().required("Name is required!"),
    type: yup.string().required("Type is required!"),
  });
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm({
    resolver: yupResolver(actionSchema),
    defaultValues: {
      name: "",
      type: "get",
    },
  });
  const actionSubmit = (data: any) => {
    let actionData = { ...data };
    let action_roles: any = [];
    if (selectedRoles.length > 0) {
      setActionError("");
      selectedRoles.map((role: any) => {
        action_roles.push(role.value);
      });
      actionData["roles"] = action_roles;

      if (editActions) {
        console.log(actionData);
        dispatch(
          editAction({ project_id: id, action_id: actionId, data: actionData })
        ).then((data: any) => {
          if (!data.error) {
            toast.success("Actions edited successfully", {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }
        });
      } else {
        console.log(actionData);
        dispatch(addAction({ id: id, data: actionData })).then((data: any) => {
          if (!data.error) {
            toast.success("Actions added successfully", {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }
        });
      }
      closeActionModal();
    } else {
      setActionError("Roles is required");
    }
  };
  const submitRole = async () => {
    console.log(rolesArray);
    dispatch(addRoles({ project_id: id, data: { roles: rolesArray } })).then(
      (data: any) => {
        if (!data.error) {
          toast.success("Roles edited successfully", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
      }
    );
    // let requestApiUrl = '/project/update-role/' + id;
    // const response: any = await request('put', requestApiUrl, roles);

    // toast.success('Roles updated successfully', {
    //     position: "top-right",
    //     autoClose: 5000,
    //     hideProgressBar: false,
    //     closeOnClick: true,
    //     pauseOnHover: true,
    //     draggable: true,
    //     progress: undefined,
    // });
    closeRoleModal();
  };
  const edit = (action: any) => {
    setEditAction(true);
    console.log(action);
    setActionId(action.action_id);
    setValue("name", action.name);
    setValue("type", action.type);
    console.log(action);
    let rolesArr: any = [];
    action.roles.map((role: any) => {
      rolesArr.push({ label: role, value: role });
    });
    setSelectedRoles(rolesArr);
    rolesArr = [];
    roles.map((role: any) => {
      rolesArr.push({ label: role, value: role });
    });
    console.log(rolesArr);
    setRolesOptions(rolesArr);
    setActionModal(true);
  };
  const delete_action = (actionId: any) => {
    if (window.confirm("Do you wants to delete action ?")) {

    dispatch(deleteAction({ project_id: id, action_id: actionId }));
    toast.success("Actions removed successfully", {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  }

  };
  return (
    <>
      <table className="table data__table">
        <thead>
          <th>Name</th>
          <th>Value</th>
        </thead>
        <tbody>
          <tr>
            <td>Project Name</td>
            <td>{selectedProject.name}</td>
          </tr>
          <tr>
            <td>Project default role</td>
            <td>{selectedProject.dafault_role}</td>
          </tr>
          <tr>
            <td>Actions</td>
            <td>
              {selectedProject.actions &&
                selectedProject.actions.length > 0 &&
                selectedProject?.actions?.map((action: any) => {
                  return (
                    <div className="proj-action-container">
                      <div>
                            <span>{action.type} - </span>
                            <span>{action.name}</span>
                      </div>
                      <div className="proj-action-buttons">
                        <Button
                            type="button"
                            variant="contained"
                            className="btn-sm edit-btn"
                            color="primary"
                            onClick={() => edit(action)}
                        >
                            Edit
                        </Button>
                        <Button
                            type="button"
                            variant="contained"
                            className="btn-sm delete-btn"
                            onClick={() => delete_action(action.action_id)}
                        >
                            Delete
                        </Button>
                      </div>
                    </div>
                  );
                })}
              <Button
                type="button"
                variant="contained"
                className="btn-sm"
                color="primary"
                onClick={OpenActionModal}
              >
                Add Action
              </Button>
            </td>
          </tr>
          <tr>
            <td>Roles</td>
            <td>
                 {roles &&
                roles.length > 0 &&
                roles.map((role: any) => {
                  return (
                      <div>
                            <span>{role}</span>
                      </div>
                      )

                })}
              <Button
                variant="contained"
                color="primary"
                className="btn-sm"
                onClick={OpenRolesModal}
              >
                Add Role
              </Button>
            </td>
          </tr>
        </tbody>
      </table>

      <Modal
        open={openActionModal}
        onClose={closeActionModal}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        <div className="card custom-modal">
          <div className="card-header d-flex align-items-center border-bottom ">
            {!editActions ? (
              <h2 id="simple-modal-title" className="mb-0">
                Add action
              </h2>
            ) : (
              <h2 id="simple-modal-title" className="mb-0">
                Edit action
              </h2>
            )}

            <button className="btn close_btn" onClick={closeActionModal}>
              <span>&times;</span>
            </button>
          </div>
          <div className="card-body">
            <form onSubmit={handleSubmit(actionSubmit)}>
              <div className="mb-3">
                <label className="form-label">Name</label>
                <input
                  className="form-control"
                  {...register("name")}
                  placeholder="Name"
                />
                <p className="error">{errors.name?.message}</p>
              </div>
              <div className="mb-3">
                <label className="form-label">Type</label>
                <select className="form-control" {...register("type")}>
                  {type_list.map((type: any) => {
                    return <option value={type.value}>{type.name}</option>;
                  })}
                </select>
                <p className="error">{errors.type?.message}</p>
              </div>
              <p className="form-label" style={{ marginBottom: ".5rem" }}>
                Roles
              </p>
              <MultiSelect
                className="custom-select"
                options={rolesOption}
                value={selectedRoles}
                onChange={setSelectedRoles}
                labelledBy="Roles"
              />
              <p className="error">{actionError}</p>

              {/* </div> */}
              <Button
                className="mt-4"
                variant="contained"
                color="primary"
                type="submit"
              >
                Submit
              </Button>
            </form>
          </div>
        </div>
      </Modal>
      <Modal
        open={openRoleModal}
        onClose={closeRoleModal}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        <div className="card custom-modal">
          <div className="card-header d-flex align-items-center border-bottom ">
            <h2 id="simple-modal-title">Add Role</h2>
            <button className="btn close_btn" onClick={closeRoleModal}>
              <span>&times;</span>
            </button>
          </div>
          <div className="card-body">
            <ChipInput
              value={rolesArray}
              onAdd={(chip) => addRole(chip)}
              onDelete={(chip, index) => removeRole(chip, index)}
            />
            <Button
              variant="contained"
              color="primary"
              onClick={submitRole}
              className="mt-4"
            >
              submit
            </Button>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default ProjectView;
